import clsx from 'clsx'
import { format } from 'date-fns'
import { useState } from 'react'

import type {
    CalendarEvent,
    CalendarResource,
} from '@/compoments/features/Calendar'
import Calendar from '@/compoments/features/Calendar'
import AssignOrderModal from '@/compoments/modals/AssignOrderModal'
import PageLoader from '@/compoments/PageLoader'
import { useGetDispatcherUnassignedOrdersQuery } from '@/services/dispatcher/dispather'
import type { DispatcherUnassignment } from '@/types/dispatcher/dashboard.types'
import { enumPillStatusesClasses } from '@/types/tenant/workGroup.types'
import { getStartAndEndOfDay } from '@/utils/helpers'

const today = new Date()

const UnassignedJobs = () => {
    const [query, setQuery] = useState(getStartAndEndOfDay(today))
    const {
        data: response,
        isLoading,
        refetch,
    } = useGetDispatcherUnassignedOrdersQuery({
        query,
    })
    const data = response?.data || []

    const [assignOrderModal, setAssignOrderModal] = useState<{
        isOpen: boolean
        order: DispatcherUnassignment | null
    }>({
        isOpen: false,
        order: null,
    })

    if (isLoading) {
        return <PageLoader style={{ height: 250 }} />
    }

    const events: CalendarEvent[] = data.map(event => ({
        id: String(event.id),
        start: event.startTime,
        end: event.endTime,
        resourceId: String(event.id),
        extendedProps: {
            title: event.service.name,
            note: event.note,
            status: event.status,
        },
    }))
    const resources: CalendarResource[] = data.map(event => ({
        id: String(event.id),
    }))

    return (
        <>
            <Calendar
                events={events}
                resources={resources}
                setDateRage={setQuery}
                hideSidebar
                title="Unassigned Jobs"
            >
                <div className="table-body table-responsive p-0 bordered-split">
                    <table className="table table-custom">
                        <thead>
                            <tr>
                                <th>Job ID</th>
                                <th className="text-center">Job Type</th>
                                {/* <th>Job Location</th> */}
                                <th>Customer</th>
                                <th>Phone No.</th>
                                <th className="text-center">
                                    Job Creation Date
                                </th>
                                <th className="text-center">
                                    Appointment Date
                                </th>
                                <th className="text-center">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map(row => (
                                <tr
                                    key={row.id}
                                    onClick={() =>
                                        setAssignOrderModal({
                                            isOpen: true,
                                            order: row,
                                        })
                                    }
                                    style={{ cursor: 'pointer' }}
                                >
                                    <td>
                                        <p className="font-600">{row.id}</p>
                                    </td>
                                    <td className="text-center">
                                        {row.service.category?.name}
                                    </td>
                                    {/* <td>
                                    <p className="text-color-1">{'TODO'}</p>
                                </td> */}
                                    <td>{row.customer.fullName}</td>
                                    <td>{row.customer.phone}</td>
                                    <td className="text-center">
                                        <p className="text-color-1">
                                            {format(
                                                row.startTime,
                                                'MMM dd, yyyy',
                                            )}
                                        </p>
                                    </td>
                                    <td className="text-center">
                                        <p className="text-color-1">
                                            {format(
                                                row.endTime,
                                                'MMM dd, yyyy',
                                            )}
                                        </p>
                                    </td>
                                    <td className="text-center">
                                        <div className="flex items-center justify-center">
                                            <span
                                                className={clsx(
                                                    'pill pill-2',
                                                    enumPillStatusesClasses[
                                                        row.status
                                                    ],
                                                )}
                                            >
                                                {row.status}
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </Calendar>
            {assignOrderModal.order && (
                <AssignOrderModal
                    isOpen={assignOrderModal.isOpen}
                    order={assignOrderModal.order}
                    onClose={() =>
                        setAssignOrderModal({ isOpen: false, order: null })
                    }
                    onSubmit={refetch}
                />
            )}
        </>
    )
}

export default UnassignedJobs
